import { render, staticRenderFns } from "./groupList.vue?vue&type=template&id=aca55c8a&scoped=true&"
import script from "./groupList.vue?vue&type=script&lang=js&"
export * from "./groupList.vue?vue&type=script&lang=js&"
import style0 from "./groupList.vue?vue&type=style&index=0&id=aca55c8a&prod&lang=less&scoped=true&"
import style1 from "./groupList.vue?vue&type=style&index=1&id=aca55c8a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca55c8a",
  null
  
)

export default component.exports